import { useState } from "react";

/** Logo-ul oficial BNB Chain (cubul galben, fundal transparent), așa cum a fost trimis. */
const BNB_CHAIN_LOGO =
  "https://public.readdy.ai/ai/img_res/d9606a8d-8de7-449c-9a60-f3be57303fe5.png";

export default function UsdcIcon() {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="relative w-11 h-11 rounded-full flex items-center justify-center shrink-0">
      <img
        alt="USDC"
        title="USDC coin logo"
        className="w-full h-full rounded-full object-cover"
        src="https://static.readdy.ai/image/5561bd759c3222152be419fe80f35f20/17e3f96f651b1b6485579e313d0eb2ed.png"
      />
      {/* Insigna rețelei: cubul galben BNB Chain pe fundal negru */}
      <div className="absolute bottom-0 right-0 w-[18px] h-[18px] rounded-[5px] bg-[#000000] flex items-center justify-center overflow-hidden">
        {logoFailed ? (
          <div className="relative w-[10px] h-[10px]">
            <span
              className="absolute inset-0 bg-[#F3BA2F]"
              style={{
                clipPath: "polygon(50% 0%, 100% 25%, 51% 49%, 49% 49%, 0% 25%)",
              }}
            />
            <span
              className="absolute inset-0 bg-[#F3BA2F]"
              style={{ clipPath: "polygon(0% 27%, 49% 51%, 49% 100%, 0% 76%)" }}
            />
            <span
              className="absolute inset-0 bg-[#F3BA2F]"
              style={{ clipPath: "polygon(100% 27%, 100% 76%, 51% 100%, 51% 51%)" }}
            />
          </div>
        ) : (
          <img
            src={BNB_CHAIN_LOGO}
            alt="BNB Chain"
            title="BNB Chain"
            onError={() => setLogoFailed(true)}
            className="w-[14px] h-[14px] object-contain"
          />
        )}
      </div>
    </div>
  );
}